// App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import RouteOptimizationSystem from './RouteOptimizationSystem';
import CustomerTrackingPage from './CustomerTrackingPage';
import LoginPage from './LoginPage';
import UserList from './components/User/UserList';
import UserForm from './components/User/UserForm';
import RoleList from './components/Role/RoleList';
import RoleForm from './components/Role/RoleForm';

const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated');
  return isAuthenticated ? children : <Navigate to="/" />;
};

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<LoginPage />} />

        {/* Private Routes */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <RouteOptimizationSystem />
            </PrivateRoute>
          }
        />
        <Route
          path="/customer_tracking"
          element={
            <PrivateRoute>
              <CustomerTrackingPage />
            </PrivateRoute>
          }
        />

        {/* User Management Routes */}
        <Route
          path="/users"
          element={
            <PrivateRoute>
              <UserList />
            </PrivateRoute>
          }
        />
        <Route
          path="/users/add"
          element={
            <PrivateRoute>
              <UserForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/users/edit/:id"
          element={
            <PrivateRoute>
              <UserForm />
            </PrivateRoute>
          }
        />

        {/* Role Management Routes */}
        <Route
          path="/roles"
          element={
            <PrivateRoute>
              <RoleList />
            </PrivateRoute>
          }
        />
        <Route
          path="/roles/add"
          element={
            <PrivateRoute>
              <RoleForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/roles/edit/:id"
          element={
            <PrivateRoute>
              <RoleForm />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
